import styled from 'styled-components'

export const CardTitle = styled.h1`
  font-family: 'HonestMaria';
  font-size: 36px;
  margin: 0;
  font-weight: normal;
`

export const CardSubheader = styled.h2`
  font-family: 'HonestMaria';
  margin-top: -16px;
  font-weight: normal;
`

export const CardDescriptionSubheader = styled.h3`
  margin: 0;
`
